import React from 'react';
import wb0 from '../img/Detail/tavsi_detail.jpg';
import './Detail.css';
const TavsiDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Kuş" />
    </div>
    
  );
};

export default TavsiDetail;